import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { ComponentPrivate } from "src/Pages/components/ComponentPrivate/ComponentPrivate";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";

import { HeaderIsPlanTest } from "./components/HeaderIsPlanTest/HeaderIsPlanTest";
import { FormFilterHome } from "./components/Form";
import { TableRankingCorretores } from "./components/TableRankingCorretores/TableRankingCorretores";
import { CardsBalancesHome } from "./components/CardsBalances";
import { Grid, } from "@mui/material";
import { GraphicProduction } from "./components/GraphicProduction/GraphicProduction";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";
import { CardInstallments } from "./components/CardInstallments/CardInstallments";
import { TopsProducers } from "./components/TopsProducers/TopsProducers";
import { GraphicPieIndex } from "./components/GraphicPie";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";
import { UseVerifyIsPermissionsUser } from "src/Pages/components/hooks/UseVerifyIsPermissionsUser";

export const PageHome = () => {
  const { userPerfil } = useAuthContext();
  const { filterHome } = useMetricsContext();
  const { handleVerifyViewsIndexOf } = UseVerifyIsPermissionsUser();
  return (
    <>
      <ComponentPrivate isView={handleVerifyViewsIndexOf(valuesPermissions.DASHBOARD_HOME.VER_TELA.id)}>
        <HeaderIsPlanTest />

        <ComponentPrivate isView={userPerfil?.type_user !== "PRODUCER"}>
          <CardHeaderCore
            buttonAdd={[<FormFilterHome key={1} />]}
            icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}

            sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}

            title={`Filtro: ${FormatDateBR(filterHome.startDate)} até ${FormatDateBR(filterHome.endDate)}`}
          />

          <CardsBalancesHome />

          <Grid container spacing={2} alignItems="flex-start">
            <Grid container item spacing={2} md={7.5} xl={8}>
              <Grid item md={12} xs={12}>
                <GraphicProduction />
              </Grid>

              <GraphicPieIndex />
            </Grid>

            <Grid container item spacing={4} md={4.5} xl={4} alignItems="flex-start">
              <Grid container item spacing={0} md={12} xs={12}>
                <CardInstallments />
              </Grid>

              <Grid container item spacing={0} md={12} xs={12}>
                <TopsProducers />
              </Grid>
            </Grid>
          </Grid>

          <TableRankingCorretores />
        </ComponentPrivate>
      </ComponentPrivate>
    </>
  );
};
